import React from 'react'
import { FareDetails as FareDetailsTypes } from './types'
import { formatCurrency } from '@/lib/utils';
import { useSelector } from 'react-redux';

function FareDetails({ data }: { data: FareDetailsTypes }) {
  const flightSearchInput = useSelector((state) => state.flightSearch);

  return (
    <div className="mt-3 flex flex-1 flex-col rounded-2xl border-2 border-light">
      <div className="flex flex-1 flex-row border-b-2 border-light text-text_secondary">
        <div className={`basis-[70%] border-r-2 border-light ${flightSearchInput?.travelType === 'RT' ? 'p-2' : 'p-4'}`}>
          <h4 className={`font-semibold ${flightSearchInput?.travelType === 'RT' ? 'text-[10px]' : 'text-sm'}`}>Base Fare</h4>
        </div>
        <div className={`basis-[30%] text-center ${flightSearchInput?.travelType === 'RT' ? 'p-2' : 'p-4'}`}>
          <h4 className={`font-semibold ${flightSearchInput?.travelType === 'RT' ? 'text-[10px]' : 'text-sm'}`}>
            {formatCurrency(data?.base_fare)}
          </h4>
        </div>
      </div>

      <div className="flex flex-1 flex-row border-b-2 border-light text-text_secondary">
        <div className={`basis-[70%] border-r-2 border-light ${flightSearchInput?.travelType === 'RT' ? 'p-2' : 'p-4'}`}>
          <h4 className={`font-semibold ${flightSearchInput?.travelType === 'RT' ? 'text-[10px]' : 'text-sm'}`}>Taxes and Fees </h4>
        </div>
        <div className={`basis-[30%] text-center ${flightSearchInput?.travelType === 'RT' ? 'p-2' : 'p-4'}`}>
          <h4 className={`font-semibold ${flightSearchInput?.travelType === 'RT' ? 'text-[10px]' : 'text-sm'}`}>
            {formatCurrency(
              Math.abs(
                (Number(data?.tax_and_fees) + Number(data?.airline_gst) + Number(data?.yq_tax) + Number(data?.yr_tax)) +
                Number(data?.admin_markup) + Number(data?.admin_markup_gst)
              )
            )}
          </h4>
        </div>
      </div>

      <div className="flex flex-1 flex-row border-light text-text_secondary">
        <div className={`basis-[70%] border-r-2 border-light ${flightSearchInput?.travelType === 'RT' ? 'p-2' : 'p-4'}`}>
          <h4 className={`font-semibold ${flightSearchInput?.travelType === 'RT' ? 'text-[10px]' : 'text-sm'}`}>Net Fare </h4>
        </div>
        <div className={`basis-[30%] text-center ${flightSearchInput?.travelType === 'RT' ? 'p-2' : 'p-4'}`}>
          <h4 className={`font-semibold ${flightSearchInput?.travelType === 'RT' ? 'text-[10px]' : 'text-sm'}`}>
            {formatCurrency(
              Math.abs(
                Number(data?.net_fare)
              ),
              // -
              //     Number(data?.management_fee) -
              //     Number(data?.management_fee_tax)
            )}
          </h4>
        </div>
      </div>
    </div>
  );
}

export default FareDetails
